var _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioButtonEnabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.82294,
    y: 1.823,
    width: 22.3542,
    height: 22.3542,
    rx: 5.13542,
    stroke: "#71F0FF",
    strokeWidth: 1.8125
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.75006,
    y: 5.75,
    width: 14.5,
    height: 14.5,
    rx: 2.71875,
    fill: "#71F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonEnabled);
export default __webpack_public_path__ + "static/media/RadioButtonEnabled.9ea8213a2792d4be4846ad41f8027852.svg";
export { ForwardRef as ReactComponent };